var generateStyle = function generateStyle(componentTheme) {
  return {
    onHover: {
      borderRight: "".concat(componentTheme.hoverBorderWidth, " solid ").concat(componentTheme.hoverBorderColor)
    }
  };
};
export default generateStyle;